import { OdinController } from '@myosh/odin-components';
import React from 'react';
import MultiselectPersonField from './multiselect-person-field.component';
import type { MultiselectPersonFieldProps } from './multiselect-person-field.component';

interface HfMultiselectPersonFieldProps extends MultiselectPersonFieldProps {}

export default function HfMultiselectPersonField(props: HfMultiselectPersonFieldProps) {
  const { name, control, value, onChange, ...rest } = props;
  return (
    <OdinController
      name={name as string}
      control={control}
      defaultValue={value}
      onChange={onChange}
      render={({ field: { ref: fieldRef, onChange, value }, fieldState: { error } }) => (
        <MultiselectPersonField
          {...rest}
          control={control}
          value={value}
          onChange={onChange}
          error={error?.message}
          inputRef={fieldRef}
        />
      )}
    />
  );
}
